import Header from '../components/Header';
import Footer from '../components/Footer';
import { Outlet } from 'react-router-dom';

const MainLayout = ({ services, onServiceSelect }) => {
  return (
    <>
      <Header services={services} onServiceSelect={onServiceSelect} />
      <main>
        <Outlet />
      </main>
      <Footer />
    </>
  );
};

export default MainLayout;
